import React from 'react';
import styled from 'styled-components';

import { Typography } from '@material-ui/core';

const Root = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex: 1 0 auto;

	.step {
		width: 33.333333%;

		button {
			display: flex;
			align-items: center;
			margin: 0;
			padding: 0;
			background-color: transparent;
			border: 0;
			color: white;
			cursor: pointer;
		}

		&.is-inactive {
			opacity: 0.2;

			&:hover {
				opacity: 1;
			}
		}
	}

	/* overflow: hidden;
	flex-direction: row;

	.bsactive {
		cursor: pointer;
		opacity: 1;
	}

	.bsinactive {
		cursor: pointer;
		opacity: 0.2;

		&:hover {
			opacity: 1;
		}
	}

	.avatarText {
		display: contents;
		font-weight: 700;
	}

	.iconContainer {
		display: inline-block;
	} */
`;

const NumberAvatar = styled.div`
	width: 40px;
	height: 40px;
	margin-right: 10px;
	padding: 11px;
	font-size: 16px;
	font-weight: bold;
	background-color: ${(props) =>
		props.theme.palette.blocks.stepper.number.backgroundColor};
	border-radius: 50%;
	color: ${(props) => props.theme.palette.blocks.stepper.number.color};
`;

const BarStepper = ({ selectedValue, currentSelected }) => (
	<Root>
		<div className={`step${currentSelected !== 0 ? ' is-inactive' : ''}`}>
			<button type="button" onClick={() => selectedValue(0)}>
				<NumberAvatar>1</NumberAvatar>
				<Typography className="avatarText">analyze.</Typography>
			</button>
		</div>
		<div className={`step${currentSelected !== 1 ? ' is-inactive' : ''}`}>
			<button type="button" onClick={() => selectedValue(1)}>
				<NumberAvatar>2</NumberAvatar>
				<Typography className="avatarText">optimize.</Typography>
			</button>
		</div>
		<div className={`step${currentSelected !== 2 ? ' is-inactive' : ''}`}>
			<button type="button" onClick={() => selectedValue(2)}>
				<NumberAvatar>3</NumberAvatar>
				<Typography className="avatarText">economize.</Typography>
			</button>
		</div>
	</Root>
);

export default BarStepper;
